// import * as moment from 'moment';
// import $ from 'jquery';
// import { getPurchaseDetails } from '../apis/marketPlace';
// import { getPermissionsData } from '../apis/rbac';
// import EventBus from '../utils/event-bus';
import { getCookie } from '../utils/common';
// import checkSmartExchangeProjects from '../apis/smartExchange';
// import { getUserData } from '../apis/profile';
// import {
//   isDefaultAvailable,
//   getRegIntelArchive,
// } from '../apis/regulatoryIntelligence';

const NotAuthorizedPaths = [
  'login',
  'register',
  'forgot',
  'reset',
  'confirmregister',
  'termsofservice',
  'verificationlink',
];

function checkAuthorization(to) {
  return NotAuthorizedPaths.indexOf(to.name) > -1 && getCookie('Authorization');
}
export const pathNotAllowed = [
  'Regulatory Reports',
  'Registration Tracker',
  'Regulatory Watch',
  'Regulatory Intelligence',
  'Smart Builder',
  'Product Classification',
  'Product Classification Rationale Report (standard)',
  'Product Classification Rationale Report (Custom )',
];

export async function beforeEach(to, from, next) {
  const roleId = parseInt(localStorage.getItem('roleId'), 10);
  if (to.path === '/') {
    next({ path: '/login' });
    return;
  }
  if (checkAuthorization(to)) {
    if (roleId && roleId === 11) {
      next({ path: '/layout/launchpad' });
      return;
    }
    next({ path: '/layout/dashboard' });
    return;
  }
  if (localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'Pageview',
      pagePath: to.path,
      pageTitle: to.meta.title,
      UserID: JSON.parse(localStorage.getItem('userId')),
      CompanyID: JSON.parse(localStorage.getItem('userData')).company,
    });
  }
  if (to.path.includes('/add-record')) {
    // if (to.path.includes('/flow/add-record?type=true')) {
    //   const purchaseDetails = await getPurchaseDetails();
    //   const purchaseDetail = purchaseDetails.find((item) => item.subscriptionId === 2);
    //   if (purchaseDetail.subscriptionId === 2 && purchaseDetail.productsAvailable >= 1) {
    //     next();
    //   } else {
    //     localStorage.setItem('triggerSubScriptionPopup', true);
    //     next({ path: '/layout/registration' });
    //   }
    // }
    if (Object.keys(to.params).length >= 1 && Object.keys(to.query).length >= 1) {
      next();
    } else if (Object.keys(to.params).length <= 0 && Object.keys(to.query).length <= 0) {
      next({ path: '/layout/registration' });
    }
    // next();
  }
  next();
}
